import { useQuery } from "@tanstack/react-query";
import importService from "../api/api";

export const useTemplates = () => {

    const { data, isLoading, error, isError, refetch } = useQuery({
        queryKey: ['importTemplates'],
        queryFn: () => importService.getTemplates(),
    });

    return {
        data: data || [],
        isLoading,
        error,
        isError,
    };

};